/**
 * Segmentos de atuação do cliente.
 *
 * Lista curada, e não texto livre, porque este campo vai virar filtro e recorte
 * de relatório: com texto livre, "Tecnologia", "TI" e "Tecnologia da
 * Informação" viram três segmentos diferentes e nenhum agrupamento funciona.
 *
 * "Outro" fica no fim de propósito — sem essa saída, quem não se encaixa
 * escolhe qualquer um só para poder salvar, e aí o dado mente.
 */
export const SEGMENTOS = [
  'Agronegócio',
  'Alimentos e bebidas',
  'Automotivo',
  'Bens de consumo',
  'Construção e engenharia',
  'Educação',
  'Energia e utilidades',
  'Entretenimento e mídia',
  'Farmacêutico',
  'Financeiro e seguros',
  'Governo e setor público',
  'Imobiliário',
  'Indústria e manufatura',
  'Jurídico',
  'Logística e transporte',
  'Marketing e publicidade',
  'Mineração e siderurgia',
  'Consultoria e serviços profissionais',
  'Saúde e bem-estar',
  'Tecnologia e software',
  'Telecomunicações',
  'Terceiro setor e ONGs',
  'Turismo e eventos',
  'Varejo e e-commerce',
  'Outro',
] as const;
